import { isViewer } from 'shared/domain/role/isViewer';
import type { UserAccess } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import { AccessLevelModel } from './types';
import type { UserRole } from 'shared/types/userRole';

export function findUserAccessLevelInIssueAccesses(
  userAccesses: UserAccess[],
  userRole: UserRole,
  userId: string
): AccessLevelModel {
  const userAccess = userAccesses.find(
    (access) => access.accessingUser === userId
  );

  if (userAccess) {
    return userAccess.accessLevel;
  } else {
    return isViewer(userRole)
      ? AccessLevelModel.READ
      : AccessLevelModel.NONE;
  }
}
